<div class="modal-header">
    <h4 class="modal-title">
        <i class="fas fa-dumbbell mr-2 text-warning"></i>
        Epreuve de préparation
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="alert alert-warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <strong>Attention</strong> — Ceci est une épreuve de préparation, pas l'examen officiel.
    </div>
    <p>
        Vous êtes sur le point de lancer <strong>{{ mockTest.label }}</strong>, une épreuve d'entraînement pour
        la certification <strong>{{ exam.certification.title }}</strong>.
    </p>
    <p class="text-muted">
        Votre résultat à cet entraînement n'a aucune valeur officielle et ne sera pas transmis à France Compétences.
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-warning" (click)="confirm()">
        <i class="fas fa-play mr-1"></i>
        Lancer l'entraînement
    </button>
</div>
